<mat-card class="support-requests">
    <mat-card-title class="support-requests__header">
      <h5 class="support-requests__title">Contractors</h5>
    </mat-card-title>
  
    <mat-card-content class="support-requests__content">
      
    </mat-card-content>
</mat-card>
  